import React, { useEffect, useState } from 'react'
import { PageLink, PageTitle } from '../../../../../../../_metronic/layout/core'
import JourneyManagerToolbar from './JourneyManagerToolbar'
import { useIntl } from 'react-intl'
import JourneyManagerListing from './components/JourneyManagerListing'
import JourneyService from '../../../../../../services/Crm/JourneyService'
import JourneyManagerDetails from './components/JourneyManagerDetails'
import format from 'date-fns/format'
import { addDays } from 'date-fns'
import JourneyHeaderDate from '../../../../../../../_metronic/partials/common/JourneyHeaderDate'

const JourneyManagerWrapper: React.FC = () => {
  const intl = useIntl()
  const [isLoading, setIsLoading] = useState(false)
  const [selectedJourney, setSelectedJourney] = useState<IJourney|null>(null)
  const [selectedId, setSelectedId] = useState<string|undefined>()
  const [date, setDate] = useState<string>(format(new Date(), 'MM/dd/yyyy'))

  const nextDate = () => {
    setDate(format(addDays(new Date(date), 1), 'MM/dd/yyyy'))
  }

  const previousDate = () => {
    setDate(format(addDays(new Date(date), -1), 'MM/dd/yyyy'))
  }

  const journeyBreadCrumbs : Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'home.label' }),
      path: '',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: false,
      isActive: false,
    },
  ]

  const handleSelectedId = (uuid: string) => {
    setIsLoading(true)
    setSelectedId(uuid)
  }

  useEffect(() => {
    if (selectedId) {
      JourneyService.getJourney(selectedId).then((response) => {
        setSelectedJourney(response.data.data)
        setIsLoading(false)
      })
    }
  }, [selectedId, isLoading])

  useEffect(() => {
  }, [])

  useEffect(() => {}, [selectedJourney])

  return (
    <>
      <PageTitle breadcrumbs={journeyBreadCrumbs} pageTitle={intl.formatMessage({ id: 'journey.list' })}>
        <JourneyManagerToolbar/>
      </PageTitle>
      <JourneyHeaderDate date={date} nextDate={nextDate} previousDate={previousDate} />
      <div className='row'>
        <div className='col-xxl-4'>
          <JourneyManagerListing selectedId={selectedId} handleSelectedId={handleSelectedId}/>
        </div>

        <div className={`col-xxl-8 px-0 ${isLoading ? 'overlay overlay-block' : ''}`}>

          {selectedJourney ?
            <JourneyManagerDetails journey={selectedJourney} isLoading={isLoading} setIsLoading={setIsLoading}/> :
            <div className="d-flex align-items-center justify-content-center">
              <span className="fs-1 fw-bold mt-20">Please select a journey</span>
            </div>
          }

        </div>
      </div>

    </>
  )
}

export default JourneyManagerWrapper
